if (!customElements.get('db-free-shipping')) {
  customElements.define(
    'db-free-shipping',
    class DbFreeShipping extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          // Le tiroir et la page panier sont re-rendus par Dawn : seule la barre « produit » a besoin du recalcul
          if (event && event.cartData && typeof event.cartData.total_price === 'number' && event.source !== 'cart-items') {
            this.update(event.cartData.total_price);
          } else {
            this.refresh();
          }
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      refresh() {
        fetch(`${window.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => this.update(cart.total_price))
          .catch(() => {});
      }

      update(total) {
        // Après un ajout, Dawn renvoie l'article ajouté et non le panier : on recharge alors le panier
        if (total === undefined) return this.refresh();
        const threshold = parseInt(this.dataset.threshold, 10);
        const gap = parseInt(this.dataset.gap, 10);
        const remaining = threshold - total;
        const pct = Math.min(100, Math.floor((total * 100) / threshold));
        this.style.setProperty('--db-ship', pct);
        this.classList.toggle('is-done', remaining <= 0);
        const bar = this.querySelector('[role="progressbar"]');
        if (bar) bar.setAttribute('aria-valuenow', pct);

        const texts = this.querySelector('.db-ship__texts');
        if (!texts) return;
        let html;
        if (remaining > 0) {
          html = `<p class="db-ship__msg">${this.dataset.msgRemaining.replace('[amount]', this.formatMoney(remaining))}</p>`;
          if (total > 0 && remaining <= gap && this.dataset.msgUpsell) {
            html += `<p class="db-ship__sub">${this.escape(this.dataset.msgUpsell)}</p>`;
          }
        } else {
          html = `<p class="db-ship__msg">${this.escape(this.dataset.msgReached)}</p><p class="db-ship__sub">${this.escape(this.dataset.msgReachedSub)}</p>`;
        }
        texts.innerHTML = html;
      }

      escape(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '{{amount_with_comma_separator}}€';
        const group = (value, decimals, thousands, decimal) => {
          const fixed = (value / 100).toFixed(decimals).split('.');
          const whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
          return fixed[1] ? whole + decimal + fixed[1] : whole;
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return group(cents, 0, ',', '.');
            case 'amount_with_comma_separator':
              return group(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return group(cents, 0, '.', ',');
            case 'amount_with_space_separator':
              return group(cents, 2, ' ', ',');
            default:
              return group(cents, 2, ',', '.');
          }
        });
      }
    }
  );
}
